import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteMosaicAction(
    $tenantId: ID!
    $zoneId: ID!
    $actionIdentifier: FlexibleIdentifierInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          deleteAction(identifier: $actionIdentifier)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.DeleteMosaicActionMutation,
  undefined,
  graphql.schema.DeleteMosaicActionMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
